export const registrationTour = [
  {
    route: "/registration",
    target: ".org-select",
    content: "Select your organization from the dropdown.",
    placement: "left",
    disableBeacon: true
  },
  {
    route: "/registration",
    target: ".form-select-b2b",
    content: "Select your processing location from the dropdown.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".gender-select",
    content: "Select patient's gender from the dropdown.",
    placement: "bottom"
  },
  {
    route: "/registration",
    target: ".salutation-select",
    content: "Pick patient's salutation.",
    placement: "bottom"
  },
  {
    route: "/registration",
    target: ".b2b-first-name",
    content: "Please enter the patient's first name.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".b2b-age",
    content: "Please enter the patient's age.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".b2b-dob",
    content: "Please enter the patient's date of birth.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".b2b-pincode",
    content: "Please enter the patient's pincode.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".patient-documents",
    content: "Upload patient documents.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".b2b-test-search",
    content: "Search tests by typing Test Name or Test Code.",
    placement: "right"
  },
  {
    route: "/registration",
    target: ".b2b-frequently-booked-tests",
    content: "You can add frequently booked tests from here.",
    placement: "top"
  },
  {
    route: "/registration",
    target: ".frequently-booked-view-more-btn",
    content: "Click to see more frequently booked tests.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".b2b-sample-collection-date-time",
    content: "Select the sample collection date and time.",
    placement: "left"
  },
  {
    route: "/registration",
    target: ".b2b-additional-history",
    content: "Add any additional patient history if required.",
    placement: "top"
  }
];